/* import __COLOCATED_TEMPLATE__ from './calibration-toggle.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import Utils from '../../../utils/utils';

export default class CalibrationToggle extends Component {
  @service('aditools-analytics') analytics;

  get calibrationToggled() {
    return this.args.model.signalChainHandler.dac.data.calibrationToggled;
  }

  @action handleCalibrationToggleChange(toggled) {
    this.args.model.signalChainHandler.dac.data.calibrationToggled = toggled;

    if (this.args.updateAppData) this.args.updateAppData();

    this.analytics.setWebEvent(
      Utils.getToolName(),
      'toggleCalibration',
      this.args.model.signalChainHandler.dac.data.calibrationToggled ? 'toggled' : 'not toggled',
    );
  }
}
